<template>
  <div id="topmenu">
    <div class="max-width">
      <div class="dropdown nowrap">
        <button class="button" @click="dropdownlist1=true">
          <awesomeIcon icon="users"/> Gebruikers
        </button>
        <div class="dropdown-bg" v-if="dropdownlist1" @click="dropdownlist1=false"></div>
        <div class="dropdown-list" v-if="dropdownlist1">
          <ul class="list">
            <li
              @click="viewPage('Activity');
              dropdownlist1=false"
              class="icon"
              :class="{'selected' : view === 'Activity'}"
            >
              <awesomeIcon icon="calendar"/> Activiteiten
            </li>
            <li
              @click="viewPage('Ideals'); dropdownlist1=false;"
              class="icon"
              :class="{'selected' : view === 'Ideals'}"
            >
              <awesomeIcon icon="money-check"/> iDeal
            </li>
            <li
              @click="viewPage('Users');
              dropdownlist1=false"
              class="icon"
              :class="{'selected' : view === 'Users'}"
            >
              <awesomeIcon icon="users"/> Gebruikers
            </li>
            <li
              @click="viewPage('Intakes');
              dropdownlist1=false"
              class="icon"
              :class="{'selected' : view === 'Intakes'}"
            >
              <awesomeIcon icon="address-book"/> Intakes
            </li>
          </ul>
          <div class="dropdown-cancel" @click="dropdownlist1=false">
            Annuleren
          </div>
        </div>
      </div>
      <div class="dropdown nowrap">
        <button class="button" @click="dropdownlist2 = true">
          <awesomeIcon icon="chart-line"/> Portefeuilles
        </button>
        <div class="dropdown-bg" v-if="dropdownlist2" @click="dropdownlist2=false"></div>
        <div class="dropdown-list" v-if="dropdownlist2">
          <ul class="list">
            <li
              @click="viewPage('Assets');
              dropdownlist2=false"
              class="icon"
              :class="{'selected' : view === 'Assets'}"
            >
              <awesomeIcon icon="file-alt"/> Fondsbeheer
            </li>
            <li
              @click="viewPage('Profiles');
              dropdownlist2=false"
              class="icon"
              :class="{'selected' : view === 'Profiles'}"
            >
              <awesomeIcon icon="chart-bar"/> Profielen
            </li>
            <li
              @click="viewPage('Ports');
              dropdownlist2=false"
              class="icon"
              :class="{'selected' : view === 'Ports'}"
            >
              <awesomeIcon icon="wallet"/> Portefeuilles
            </li>
            <li
              @click="viewPage('Notifications');
              dropdownlist2=false"
              class="icon"
              :class="{'selected' : view === 'Notifications'}"
            >
              <awesomeIcon icon="envelope"/> Notificaties
            </li>
            <li
              @click="viewPage('Sats');
              dropdownlist2=false"
              class="icon"
              :class="{'selected' : view === 'Sats'}"
            >
              <awesomeIcon icon="fa-regular fa-circle-dot"/> Sats
            </li>
            <li
              @click="viewPage('Deltas');
              dropdownlist2=false"
              class="icon"
              :class="{'selected' : view === 'Deltas'}"
            >
              <awesomeIcon icon="fa-regular fa-circle-dot"/> Port deltas
            </li>
            <li
              @click="viewPage('RiskCalendar');
              dropdownlist2=false"
              class="icon"
              :class="{'selected' : view === 'RiskCalendar'}"
            >
              <awesomeIcon icon="fa-regular fa-circle-dot"/> Port risks
            </li>
            <li
              @click="viewPage('RiskModule');
              dropdownlist2 = false"
              class="icon"
              :class="{'selected' : view === 'RiskModule'}"
            >
              <awesomeIcon icon="check-square"/> Risk online
            </li>
          </ul>
          <div class="dropdown-cancel" @click="dropdownlist2 = !dropdownlist2">
            Annuleren
          </div>
        </div>
      </div>
      <div class="dropdown nowrap">
        <button class="button" @click="dropdownlist3 = true">
          <awesomeIcon icon="tools"/> Tools
        </button>
        <div class="dropdown-bg" v-if="dropdownlist3" @click="dropdownlist3=false"></div>
        <div class="dropdown-list" v-if="dropdownlist3">
          <ul class="list">
            <li
              @click="viewPage('NPS');
              dropdownlist3=false"
              class="icon"
              :class="{'selected' : view === 'NPS'}"
            >
              <awesomeIcon icon="star-half-alt"/> NPS
            </li>
            <li
              @click="viewPage('VKM');
              dropdownlist3=false"
              class="icon"
              :class="{'selected' : view === 'VKM'}"
            >
              <awesomeIcon icon="money-check"/> VKM
            </li>
            <li
              @click="viewPage('AdminUserCosts');
              dropdownlist3=false"
              class="icon"
              :class="{'selected' : view === 'AdminUserCosts'}"
            >
              <awesomeIcon icon="sticky-note"/> Kosten
            </li>
            <li
              v-if="
                Number($store.state.role) === 10
                && (Number($store.state.client) === 12056 || Number($store.state.client) === 1)
              "
              @click="viewPage('Offer');dropdownlist3=false"
              class="icon"
              :class="{'selected' : view === 'Offer'}"
            >
              <awesomeIcon icon="file-alt"/> Offertes
            </li>
            <li
              @click="viewPage('Payouts');
              dropdownlist3=false"
              class="icon"
              :class="{'selected' : view === 'Payouts'}"
            >
              <awesomeIcon icon="file-alt"/> Uitbetalingen
            </li>
            <li
              @click="viewPage('Payouts2');
              dropdownlist3=false"
              class="icon"
              :class="{'selected' : view === 'Payouts2'}"
            >
              <awesomeIcon icon="file-alt"/> Offerte kalender
            </li>
            <li
              @click="viewPage('Archive');
              dropdownlist3=false"
              class="icon"
              :class="{'selected' : view === 'Archive'}"
            >
              <awesomeIcon icon="folder"/> Archief
            </li>
            <li
              @click="viewPage('Ureturn');
              dropdownlist3=false"
              class="icon"
              :class="{'selected' : view === 'Ureturn'}"
            >
              <awesomeIcon icon="chart-bar"/> U-rendement
            </li>
          </ul>
          <div class="dropdown-cancel" @click="dropdownlist3=false">
            Annuleren
          </div>
        </div>
      </div>
      <div class="settings">
        {{roleName}} <b>{{name}}</b>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'topMenu',
  props: {
    side: {
      type: String,
      required: false,
      default: 'left',
    },
    logo: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      style: process.env.VUE_APP_STYLE,
      dropdownlist1: false,
      dropdownlist2: false,
      dropdownlist3: false,
    };
  },
  computed: {
    view() {
      return this.$store.state.currentView;
    },
    role() {
      return this.$store.state.role;
    },
    roleName() {
      if (Number(this.$store.state.role) === 10) {
        return 'Superadmin';
      }
      if (Number(this.$store.state.role) === 9) {
        return 'Admin';
      }
      if (Number(this.$store.state.role) === 8) {
        return 'Beheerder';
      }
      if (Number(this.$store.state.role) === 0) {
        return 'Gebruiker';
      }
      return 'Lead';
    },
    name() {
      return this.$store.state.name;
    },
  },
  methods: {
    viewPage(page) {
      this.$store.state.currentView = page;
    },
    unBecome() {
      this.sdk.unbecome(() => {
        window.location.reload();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  #topmenu {
    @media screen and (max-width: 1440px) {
      margin-left: -20px;
      margin-right: -20px;
    }
    background-color: $color-grey-dark;
    @media print { display: none; }
    @media screen and (max-width: 988px) { display: none; }
    button {
      background-color: transparent;
      color: rgba(#000, .5);
      &:hover {
        color: #000;
      }
    }
  }
  .max-width {
    margin: 0px auto;
    max-width: 980px;
  }
  .dropdown {
    margin: 10px;
    display: inline-block;
  }
  .settings {
    float: right;
    padding: 10px 0px;
    margin: 10px;
    border-radius: $br;
  }
  .dropdown-list .list li.selected {
    background-color: rgba($color-highlight, .3);
  }
</style>
